var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0303 7.46967C14.7374 7.17678 14.2626 7.17678 13.9697 7.46967L9.96967 11.4697C9.67678 11.7626 9.67678 12.2374 9.96967 12.5303L13.9697 16.5303C14.2626 16.8232 14.7374 16.8232 15.0303 16.5303C15.3232 16.2374 15.3232 15.7626 15.0303 15.4697L11.5607 12L15.0303 8.53033C15.3232 8.23744 15.3232 7.76256 15.0303 7.46967Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyArrow);
export default __webpack_public_path__ + "static/media/GreyArrow.6930a63ef400d73b4de19a79d4c7478c.svg";
export { ForwardRef as ReactComponent };